import { ApiInstance } from '../instance';
import { Target } from '../../types';

export const TargetingController = {
  searchLocations: async (query: string): Promise<Target[]> => {
    const response = await ApiInstance.get<Target[]>(`/advertisers/zip-metro/search`, {
      params: { value: query },
    });

    return response.data;
  },
};
